import { render, staticRenderFns } from "./TheAutomator.vue?vue&type=template&id=c32e741e&scoped=true"
import script from "./TheAutomator.vue?vue&type=script&lang=js"
export * from "./TheAutomator.vue?vue&type=script&lang=js"
import style0 from "./TheAutomator.vue?vue&type=style&index=0&id=c32e741e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32e741e",
  null
  
)

export default component.exports